import styled from 'styled-components'
import Divider from 'components/Divider'

const NavActiveBar = styled(Divider).withConfig({
  shouldForwardProp: prop => ![
    'left',
    'right',
    'show',
  ].includes(prop),
}).attrs(props => ({
  vertical: true,
  color: 'primaryHue',
  thickness: 'thickest',
}))`
  position: absolute;
  left: ${props => props.left};
  ${props =>
    props.left
      ? `left: ${props.left};`
      : props.right
      ? `right: ${props.right};`
      : ''}
  top: 0;
  bottom: 0;
  margin: auto;
  opacity: ${props => (props.show ? '1' : '0')};
  transition: ${props => props.theme.state.transition.main};
`

export default NavActiveBar
